import { DOMOutputSpecArray, Mark, MarkSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class LinkMark implements MarkSpec {
  public static readonly markName = MarkName.Link;
  public static is(mark: Mark) {
    return mark.type.name === LinkMark.markName;
  }
  public attrs = {
    href: {},
    target: { default: null },
  };
  public inclusive = false;
  public parseDOM = [
    {
      tag: 'a[href]',
      getAttrs: (dom: HTMLElement) => ({
        href: dom.getAttribute('href'),
        target: dom.getAttribute('target'),
      }),
    },
  ];
  public toDOM(node: Mark): DOMOutputSpecArray {
    const { href, target } = node.attrs;
    return ['a', { href, target }, 0];
  }
}

export type LinkSchema = RtSchemaType<any, typeof LinkMark>;
